import { COLOR_MAP } from "../ColorNames"

export const PillFilled = ({ height = "24", percentage = 0, fill = COLOR_MAP.GREEN }) => {
  const maxWidth = 0.61 * percentage;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} width={maxWidth} viewBox={`0 0 ${maxWidth} 24`} fill="none">
      <path d={`
        M 0 12
        C 0 5.37258   5.37258 0  12 0
        H ${maxWidth - 1}
        L ${maxWidth - 0.2443} 4.28227
        C ${maxWidth + 0.2408} 7.0314   ${maxWidth - 0.1057} 9.86276   ${maxWidth - 1.2494} 12.4138
        C ${maxWidth - 2.6869} 15.6704    ${maxWidth - 2.7813} 19.3687   ${maxWidth - 1.5019} 22.695
        L ${maxWidth - 1} 24
        H 12
        C 5.37258 24  0 18.6274   0 12Z
      `} fill={fill} />
    </svg>
  )
}